import { PAGEPATHS } from "components/Common/Constant"
import React, { useEffect, useState } from "react"
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom" //
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { TableHeader } from "components/Common/common";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import "./datatables.scss"
import ReactApexChart from 'react-apexcharts';
import DataTableWithPopup from "components/longContentTable";

const Accessibility = (props) => {
    document.title = "Accessibility Overview";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [a11yScanData, setA11yScanData] = useState({
        columns: [
            {
                label: "URL",
                field: "url",
                sort: "asc",
                width: 150,
            },
            {
                label: "Organization",
                field: "organization",
                sort: "asc",
                width: 270,
            },
            {
                label: "User",
                field: "user",
                sort: "asc",
                width: 200,
            },
            {
                label: "Domain",
                field: "Domain",
                sort: "asc",
                width: 100,
            },
            {
                label: "Type Code",
                field: "typeCode",
                sort: "asc",
                width: 100,
            },
            {
                label: "Code",
                field: "code",
                sort: "asc",
                width: 150,
            },
            {
                label: "Message",
                field: "messages",
                sort: "asc",
                width: 150,
            },
            {
                label: "Context",
                field: "context",
                sort: "asc",
                width: 150,
            },
            {
                label: "Selector",
                field: "selector",
                sort: "asc",
                width: 150,
            }
        ],
        rows: []
    })

    const [lightHouseScanData, setLightHouseScanData] = useState({
        columns: [
            {
                label: "URL",
                field: "url",
                sort: "asc",
                width: 150,
            },
            {
                label: "Organization",
                field: "organization",
                sort: "asc",
                width: 270,
            },
            {
                label: "User",
                field: "user",
                sort: "asc",
                width: 200,
            },
            {
                label: "Domain",
                field: "Domain",
                sort: "asc",
                width: 100,
            },
            {
                label: "Audit",
                field: "audit",
                sort: "asc",
                width: 100,
            },
            {
                label: "Score",
                field: "score",
                sort: "asc",
                width: 150,
            },
            {
                label: "Display Value",
                field: "displayValue",
                sort: "asc",
                width: 150,
            },
            {
                label: "Description",
                field: "description",
                sort: "asc",
                width: 150,
            },
            {
                label: "Details",
                field: "details",
                sort: "asc",
                width: 150,
            }
        ],
        rows: []
    })

    const [pieA11yoptions, setPieA11yoptions] = useState({
        chart: {
            type: 'donut',
        },
        title: {
            text: 'A11y Scan Codes Distribution',
            align: 'center',
            style: {
                fontSize: '18px',
                fontWeight: 'bold',
            },
        },
        legend: {
            position: 'right',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            itemMargin: {
                horizontal: 10,
                vertical: 8,
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '65%',
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        tooltip: {
            y: {
                formatter: (val) => `${val} issues`,
            },
        },
        responsive: [
            {
                breakpoint: 1024,
                options: {
                    chart: {
                        height: 450,
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'center',
                        floating: false,
                        fontSize: '13px',
                    },
                    title: {
                        style: { fontSize: '16px' },
                    },
                },
            },
            {
                breakpoint: 768,
                options: {
                    chart: {
                        height: 400,
                    },
                    legend: {
                        position: 'bottom',
                        fontSize: '12px',
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '60%',
                            },
                        },
                    },
                },
            },
            {
                breakpoint: 480,
                options: {
                    chart: {
                        height: 350,
                    },
                    legend: {
                        position: 'bottom',
                        fontSize: '11px',
                    },
                    title: {
                        style: { fontSize: '14px' },
                    },
                },
            },
        ],
    });

    const [pieLHoptions, setPieLHoptions] = useState({
        chart: {
            type: 'donut',
        },
        legend: {
            position: 'right',
            horizontalAlign: 'center',
            floating: false,
            fontSize: '14px',
            markers: {
                width: 12,
                height: 12,
            },
        },
        labels: [],
        title: {
            text: 'Light House Scan Audit Distribution',
            align: 'center',
            style: {
                fontSize: '18px',
                fontWeight: 'bold',
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '65%',
                },
                expandOnClick: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        tooltip: {
            y: {
                formatter: (val) => `${val} issues`,
            },
        },
        responsive: [
            {
                breakpoint: 1024,
                options: {
                    chart: {
                        height: 400,
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'center',
                        fontSize: '13px',
                    },
                    title: {
                        style: {
                            fontSize: '16px',
                        },
                    },
                },
            },
            {
                breakpoint: 768,
                options: {
                    chart: {
                        height: 350,
                    },
                    legend: {
                        fontSize: '12px',
                        markers: {
                            width: 10,
                            height: 10,
                        },
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '60%',
                            },
                        },
                    },
                },
            },
            {
                breakpoint: 480,
                options: {
                    chart: {
                        height: 300,
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'center',
                        fontSize: '11px',
                    },
                    title: {
                        style: {
                            fontSize: '14px',
                        },
                    },
                },
            },
        ],
    });

    const [pieA11yseries, setPieA11yseries] = useState([]);

    const [pieLHseries, setPieLHseries] = useState([]);
    const [barChartA11yData, setBarChartA11yData] = useState([]);
    const [barChartLHData, setBarChartLHData] = useState([]);


    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Accessibility", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Accessibility", breadcrumbItems)
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_A11Y_SCAN}/${scanId}`)
                data.data.list = data.data.list.map(obj => {
                    return Object.fromEntries(
                        Object.entries(obj).map(([key, value]) => [
                            key, typeof value === 'number' || typeof value === 'boolean'
                                ? value.toString()
                                : value === null
                                    ? 'NaN'
                                    : value
                        ])
                    );
                });
                setA11yScanData((prev) => ({
                    ...prev,
                    columns: prev.columns,
                    rows: data.data.list
                }))
                const barChartData = data.data.list.reduce((acc, data) => {
                    if (acc.length && acc.some(c => c.code === data.code)) {
                        acc.forEach(v => {
                            if (v.code === data.code)
                                v.count = v.count + 1
                        });
                    } else {
                        const value = {
                            code: data.code,
                            count: 1
                        }
                        acc.push(value)
                    }
                    return acc
                }, [])
                setBarChartA11yData(barChartData)
                setPieA11yseries(barChartData.map(item => item.count))
                setPieA11yoptions((prev) => ({
                    ...prev,
                    labels: barChartData.map(item => item.code),
                }))
            } catch (e) {
                console.error(e);
            }
        }
        fetchData()
    }, [scanId])

    useEffect(() => {
        const fetchLightHouseData = async () => {
            try {
                const { data } = await axiosInstance
                    .get(`${ApiNames.FETCH_LIGHTHOUSE_CATEGORY_SCAN}/accessibility/${scanId}`)
                const barChartData = data.data.reduce((acc, data) => {
                    if (acc.length && acc.some(c => c.audit === data.audit)) {
                        acc.forEach(v => {
                            if (v.audit === data.audit)
                                v.count = v.count + 1
                        });
                    } else {
                        const value = {
                            audit: data.audit,
                            count: 1
                        }
                        acc.push(value)
                    }
                    return acc
                }, [])
                setBarChartLHData(barChartData)
                setPieLHseries(barChartData.map(item => item.count))
                setPieLHoptions((prev) => ({
                    ...prev,
                    labels: barChartData.map(item => item.audit),
                }))
                data.data = data.data.map(obj => {
                    return Object.fromEntries(
                        Object.entries(obj).map(([key, value]) => [
                            key, typeof value === 'number' || typeof value === 'boolean'
                                ? value.toString()
                                : value === null
                                    ? 'NaN'
                                    : value
                        ])
                    );
                });
                setLightHouseScanData((prev) => ({
                    ...prev,
                    columns: prev.columns,
                    rows: data.data
                }))
            } catch (e) {
                console.error(e);
            }
        }
        fetchLightHouseData()
    }, [scanId])

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12 accessibility-container">
                    <Card>
                        <TableHeader scanName={'A11y Scan'} scanId={scanId} />
                        <CardBody>
                            {a11yScanData && a11yScanData.rows && (
                                <DataTableWithPopup noBottomColumns={false} thirdPartyData={a11yScanData} />
                            )}
                        </CardBody>
                    </Card>
                    <Card className="py-0 md:py-6">
                        <CardBody>
                            {pieA11yoptions.labels && pieA11yseries.length !== 0 && (
                                <ReactApexChart
                                    options={pieA11yoptions}
                                    series={pieA11yseries}
                                    type="donut"
                                    height={600}
                                    width="100%"
                                />
                            )}
                        </CardBody>

                    </Card>
                    <Card>
                        <TableHeader scanName={'Light House Scan'} scanId={scanId} />
                        <CardBody>
                            {lightHouseScanData && lightHouseScanData.rows && (
                                <DataTableWithPopup noBottomColumns={false} thirdPartyData={lightHouseScanData} />
                            )}
                        </CardBody>
                    </Card>
                    <Card style={{ padding: '2em 0' }}>
                        <CardBody>
                            {pieLHoptions.labels && pieLHseries.length !== 0 && (
                                <ReactApexChart
                                    options={pieLHoptions}
                                    series={pieLHseries}
                                    type="donut"
                                    height={600}
                                    width="100%"
                                />
                            )}
                        </CardBody>

                    </Card>
                    <Card 
                        className="flex-col md:flex-row"
                        style={{
                            gap: '0 3em',
                            display: 'flex',
                            justifyContent: 'space-around',
                            alignItems: 'start',
                            padding: "30px 30px 0"
                        }}>
                        <Card className="w-full md:w-2/4">
                            <TableHeader className="text-[20px]" scanName={'Accessibility issues Summmary'} scanId={null} />
                            <CardBody style={{ backgroundColor: 'rgb(254, 202, 202)', textAlign: 'center' }}>
                                <CardTitle style={{ color: '#000', fontSize: '20px' }}>Total Issues Found</CardTitle>
                                <span style={{ color: '#a70000', fontSize: '3em', fontWeight: '700' }}>{a11yScanData.rows.length + lightHouseScanData.rows.length}</span>
                            </CardBody>
                        </Card>
                        <Card className="mt-0 md:mt-[3em] md:my-[3em] w-full md:w-2/4">
                            <TableHeader scanName={'Issues & Count'} scanId={null} />
                            <CardBody style={{ display: 'flex', flexDirection: 'column', maxHeight: '30em', overflow: 'auto' }}>
                                {barChartA11yData.length !== 0 && barChartA11yData.map((value, key) => (
                                    <span style={{ fontSize: '1.1em' }} key={key}>{value.code}:<strong>{` ${value.count}`}</strong></span>
                                ))}
                                {barChartLHData.length !== 0 && barChartLHData.map((value, key) => (
                                    <span style={{ fontSize: '1.1em' }} key={key}>{value.audit}:<strong>{` ${value.count}`}</strong></span>
                                ))}
                            </CardBody>
                        </Card>
                    </Card>
                </Col>
            </Row>

        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(Accessibility)